export enum AlertType {
    primary = "primary",
    danger = "danger"
}
